module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: ['m-gotop-img', {
      'm-gotop-img--new': _vm.hasNew
    }],
    on: {
      "click": _vm.top
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-501994f1"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/funcButtons/goTop.vue
// module id = 206
// module chunks = 1